import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import { GetAddressReq, GetAddressRes } from './common.types'

export const changeToken = createStandardAction('CHANGE_TOKEN')<string>()

export const getAddressAction = createAsyncAction(
  'COMMON/GET_ADDRESS_REQ',
  'COMMON/GET_ADDRESS_SUCCESS',
  'COMMON/GET_ADDRESS_FAILURE',
)<GetAddressReq, GetAddressRes, Error>()
